import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false,
  standalone: true,
})
@Injectable()
export class CustomFilterPipe implements PipeTransform {
  static filter<T>(items: Array<T>, term: string, excludes: string[] = []): Array<T> {
    const toCompare = term.toLowerCase();

    function checkInside<T>(item: T, term: string): boolean {
      if (typeof item === 'string' && item.toString().toLowerCase().includes(toCompare)) {
        return true;
      }

      for (const property in item) {
        if (item[property] === null || item[property] == undefined || excludes.includes(property)) {
          continue;
        }

        if (typeof item[property] === 'object') {
          if (checkInside(item[property], term)) {
            return true;
          }
        } else if (item[property].toString().toLowerCase().includes(toCompare)) {
          return true;
        }
      }
      return false;
    }

    return items.filter(function (item) {
      return checkInside(item, term);
    });
  }

  transform<T>(items: Array<T>, term: string, excludes: string[] = []): Array<T> {
    if (!term || !items) return items;
    return CustomFilterPipe.filter(items, term, excludes);
  }
}
